<template>
    <div class="english-container">
  
      <h2>Each product can only be paired with one device.</h2>
      <h2>IOS:</h2>
      <h1>Quick Start</h1>
      

  
      <ol>
        <li>Power on the smart card.</li>
        <li>Open the “Find My” app and tap “+”.</li>
        <li>Select “Add Other Item”.</li>
        <li>Tap “Connect”.</li>
        <li>Follow the on-screen instructions to complete the connection.</li>
      </ol>
  
      <div class="divider"></div>
  
      <h2>Locate Your Item <span>03</span></h2>
  
      <h3>1. Find Item Locator when it is Nearby</h3>
  
      <p>
        Open Find My app and select the “Items” tab.
        Tap on your Item Locator from the list.
        Tap “Play Sound” to make your Item Locator beep.
        Tap “Stop Sound” once you find your item.
      </p>
  
      <h3>2. Find Item Locator’s Last Known Location</h3>
  
      <p>
        Open Find My app and select the “Items” tab.
        Tap your Item Locator from the list.
        Your Item Locator’s last known location will appear on the map.
      </p>
  
      <div class="divider"></div>
  
      <h2>Find Item When Out of Range <span>04</span></h2>
  
      <h3>1. Enable “Notify when Left Behind”</h3>
  
      <p>
        Open Find My app and select the “Items” tab.
        Tap your Item Locator from the list.
        Under “Notifications”, enable “Notify when Left Behind”.
      </p>
  
      <h3>2. Enable “Notify when Found”</h3>
  
      <p>
        Under Notifications, enable the “Notify When Found” toggle.
        When your item is seen by another Find My enabled device,
        you will receive a notification of its updated location.
      </p>
  
      <div class="divider"></div>
  
      <h2>When Your Item is Lost <span>05</span></h2>
  
      <p>
        Open Find My app and select the “Items” tab.
        Tap your Item Locator from the list.
      </p>
  
      <p>
        Under Lost Mode, tap “Enable”.
        A screen detailing Lost Mode will pop up.
        Tap Continue and enter your phone number or email address.
      </p>
  
      <div class="divider"></div>
  
      <h2>Resetting Your Item Locator <span>06</span></h2>
  
      <h3>1. Remove the Item Locator from Find My</h3>
  
      <p>
        Open Find My app and select the “Items” tab.
        Tap your Item Locator from the list.
        Ensure “Lost Mode” is disabled.
        Scroll to the bottom and tap “Remove Item”.
      </p>
  
      <h3>2. Factory Reset Item Locator</h3>
  
      <p>
        After successfully removing the Item Locator from Find My,
        press the Item Locator’s function button four times rapidly,
        then hold it a fifth time until you hear a ringing chime.
      </p>
  
      <div class="divider"></div>
  
      <h2>But Wait... There’s More <span>07</span></h2>
  
      <h3>1. Charging</h3>
  
      <p>
        Use regular wireless charging equipment to charge the product wirelessly.
        The red light is always on when charging,
        and turns off when fully charged.
      </p>
  
      <h3>2. Unwanted Tracking Detection</h3>
  
      <p>
        If your phone detects an unknown Item Locator traveling with you,
        it will send you a notification.
      </p>
  
      <div class="divider"></div>
  
      <h2>The Fine Print</h2>
  
      <p class="small">
        This device complies with part 15 of the FCC Rules:
        Operation is subject to the following two conditions:
      </p>
  
      <ol class="small">
        <li>This device may not cause harmful interference.</li>
        <li>
          This device must accept any interference received,
          including interference that may cause undesired operation.
        </li>
      </ol>
  
      <p class="small">
        NOTE:
        The manufacturer is not responsible for any radio or TV interference
        caused by unauthorized modifications or changes to this equipment.
        Such modifications could void the user’s authority to operate this device.
      </p>
  
      <p class="small">
        This equipment has been evaluated to meet general RF exposure requirements.
        The device can be used in portable exposure condition without restriction.
      </p>
  
      <p class="small">
        This equipment has been tested and found to comply with the limits for a
        Class B digital device pursuant to part 15 of the FCC Rules.
      </p>
  
    </div>
  </template>
  
  <script>
  export default {
    name: 'CardEnglishLuage',
  };
  </script>
  
  <style scoped>
  
  .english-container{
    background-color:#ffffff;
    border-radius:8px;
    padding:30px;
    margin:10px auto;
    max-width:1000px;
    box-shadow:0 2px 8px rgba(0,0,0,0.08);
  }
  
  h1{
    font-size:42px;
    margin-bottom:25px;
    color:#222;
    text-align:left;
  }
  
  h2{
    font-size:28px;
    margin-top:35px;
    margin-bottom:15px;
    color:#222;
    text-align:left;
  }
  
  h3{
    font-size:20px;
    margin-top:24px;
    margin-bottom:10px;
    color:#333;
    text-align:left;
  }
  
  p{
    font-size:15px;
    line-height:1.8;
    color:#333;
    text-align:left;
    margin-bottom:14px;
  }
  
  ol{
    padding-left:24px;
    margin-bottom:20px;
  }
  
  li{
    font-size:15px;
    line-height:1.8;
    color:#333;
    margin-bottom:10px;
    text-align:left;
  }
  
  .small{
    font-size:13px;
    line-height:1.7;
  }
  
  .divider{
    width:100%;
    height:1px;
    background:#e5e5e5;
    margin:40px 0;
  }
  
  span{
    color:#888;
    font-weight:700;
  }
  
  .image_1{
    width:90%;
    max-width:600px;
    height:auto;
    margin:20px auto;
    display:block;
    border-radius:8px;
  }
  
  @media (max-width:768px){
  
    .english-container{
      padding:20px;
    }
  
    h1{
      font-size:32px;
    }
  
    h2{
      font-size:24px;
    }
  
    h3{
      font-size:18px;
    }
  
    p, li{
      font-size:14px;
    }
  }
  
  </style>